// <s-wishlist-button> toggles a product in a wishlist saved on the shopper's own device (localStorage),
// keeping every heart for the same product in sync across the page and other tabs.
const STORAGE_KEY = 'theme:wishlist';

const readWishlist = () => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
};

class SWishlistButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const button = this.querySelector('button');
    if (!button) return;

    button.addEventListener('click', () => this.#toggle(), opts);
    document.addEventListener('s-wishlist:change', () => this.#render(), opts);
    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY) this.#render();
    }, opts);

    this.#render();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #toggle() {
    const id = String(this.dataset.productId || '');
    if (!id) return;

    const list = readWishlist();
    const saved = list.includes(id);
    const next = saved ? list.filter((item) => item !== id) : [...list, id];

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      return;
    }

    document.dispatchEvent(new CustomEvent('s-wishlist:change'));
    const message = saved ? this.dataset.removedMessage : this.dataset.addedMessage;
    if (message) {
      document.dispatchEvent(new CustomEvent('s-notification:add', { detail: { message, variant: 'info', duration: 2500 } }));
    }
  }

  #render() {
    const button = this.querySelector('button');
    if (!button) return;
    const saved = readWishlist().includes(String(this.dataset.productId || ''));
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }
}

if (!customElements.get('s-wishlist-button')) {
  customElements.define('s-wishlist-button', SWishlistButton);
}
